var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-3",attrs:{"fluid":""}},[_c('OrderCommerceTable',{attrs:{"shop":_vm.shop,"showStat":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }